import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import {
  Form, Button, Modal, Header, Icon, Message,
} from 'semantic-ui-react';

import { utcMoment, dateTimeFormatted } from '../../utilities/dateUtils';

class DealershipBlacklistForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      expirationDate: null,
      dealerNo: '',
      notes: '',
      errors: {},
    };
  }

  componentDidMount() {
    const { dealershipBlacklist } = this.props;
    if (!isEmpty(dealershipBlacklist)) {
      const {
        id, expirationDate, dealerNo, notes,
      } = dealershipBlacklist;

      this.setState({
        id,
        expirationDate,
        dealerNo,
        notes,
      });
    }
  }

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
      action,
    } = this.props;

    const {
      errors, expirationDate, dealerNo, notes, id,
    } = this.state;

    const selectedDate = isEmpty(expirationDate)
      ? null
      : utcMoment(expirationDate);

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const onDateChangeHandler = field => dateValue => {
      this.setState({ [field]: moment(dateValue, 'YYYY-MM-DD HH:mm:ss') });
    };

    const validationRules = {
      dealerNo: 'required',
    };

    const submitForm = () => {
      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      onSubmitHandler({
        id,
        expirationDate: dateTimeFormatted(utcMoment(expirationDate)),
        dealerNo,
        notes,
      });
      this.setState({ errors: {} });
      return true;
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>
          {!id && 'Create New Dealership Blacklist'}
          {id && 'Edit Dealership Blacklist'}
        </Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            <Form>
              <Header size='small' color='blue' />
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.dealerNo)}>
                  <label htmlFor='dealerNo'>DealerNo</label>
                  <input
                    id='dealerNo'
                    name='dealerNo'
                    value={dealerNo}
                    onChange={onChangeHandler('dealerNo')}
                    readOnly={action === 'edit'}
                    className={action === 'edit' ? 'input-disabled' : ''}
                  />
                  {errors.dealerNo && <span>{errors.dealerNo}</span>}
                </Form.Field>
                <Form.Field>
                  <label htmlFor='expirationDate'>Expiration Date</label>
                  <DatePicker
                    id='expirationDate'
                    style={{ padding: '0', width: '100%' }}
                    selected={selectedDate}
                    onChange={onDateChangeHandler('expirationDate')}
                    showTimeSelect
                    timeFormat='HH:mm'
                    timeIntervals={15}
                    dateFormat='YYYY-MM-DD HH:mm:ss ZZ'
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='notes'>Notes</label>
                  <input
                    id='notes'
                    name='notes'
                    value={notes}
                    onChange={onChangeHandler('notes')}
                  />
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}
          {!submitting
            && !id && (
              <Button color='green' onClick={submitForm} inverted>
                <Icon name='checkmark' /> Create
              </Button>
          )}

          {!submitting
            && id && (
              <Button color='green' onClick={submitForm} inverted>
                <Icon name='checkmark' /> Update
              </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default DealershipBlacklistForm;

DealershipBlacklistForm.propTypes = {
  dealershipBlacklist: PropTypes.shape({
    id: PropTypes.number,
    expirationDate: PropTypes.string,
    dealerNo: PropTypes.string,
    notes: PropTypes.string,
  }),
  isModalOpen: PropTypes.bool.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  action: PropTypes.string,
};
